import { useTranslation } from 'react-i18next';
import { DownloadSimpleIcon } from '@phosphor-icons/react';
import {
  DPA_SECTIONS,
  DPA_PROCESSING_DESCRIPTION,
  DPA_SUB_PROCESSORS,
  DPA_VERSIONS,
} from '@monorepo/shared';
import { useDownloadLegalPdf } from '../../services/legalDocuments.service';
import { LegalDocumentVersions } from './LegalDocumentVersions';

export const DpaDocument = () => {
  const { t } = useTranslation();
  const { mutate: downloadLegalPdf, isPending } = useDownloadLegalPdf();

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h2 className="text-2xl font-display text-primary">{t('legal.dpa.title')}</h2>
        <button
          type="button"
          onClick={() => downloadLegalPdf('dpa')}
          disabled={isPending}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary text-white text-sm font-medium hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed transition self-start sm:self-auto"
        >
          <DownloadSimpleIcon size={18} weight="bold" />
          {isPending ? t('common.downloading') : t('common.download_pdf')}
        </button>
      </div>

      <LegalDocumentVersions versions={DPA_VERSIONS} />

      {DPA_SECTIONS.map(({ title, paragraphs }, index) => (
        <section key={index} className="mb-8">
          <h3 className="text-xl font-semibold text-primary mb-4">{title}</h3>
          {paragraphs.map((paragraph, pIndex) => (
            <p key={pIndex} className="text-text mb-3 leading-relaxed">
              {paragraph}
            </p>
          ))}
        </section>
      ))}

      <section className="mb-8">
        <h3 className="text-2xl font-display text-primary mb-6">{t('legal.dpa.appendix_title')}</h3>

        <div className="overflow-x-auto mb-8">
          <table className="w-full border-collapse border border-gray-200">
            <tbody>
              {DPA_PROCESSING_DESCRIPTION.map(({ label, value }, index) => (
                <tr key={index} className="border-b border-gray-200">
                  <td className="px-4 py-3 bg-gray-50 font-medium text-sm text-text w-1/3 align-top">
                    {label}
                  </td>
                  <td className="px-4 py-3 text-sm text-text whitespace-pre-line">{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h4 className="text-lg font-semibold text-primary mb-4">
          {t('legal.dpa.sub_processors_title')}
        </h4>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-200">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-4 py-3 text-left text-sm font-medium text-text border-b border-gray-200">
                  {t('legal.dpa.table.sub_processor')}
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-text border-b border-gray-200">
                  {t('legal.dpa.table.purpose')}
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-text border-b border-gray-200">
                  {t('legal.dpa.table.location')}
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-text border-b border-gray-200">
                  {t('legal.dpa.table.transfer_mechanism')}
                </th>
              </tr>
            </thead>
            <tbody>
              {DPA_SUB_PROCESSORS.map(({ name, purpose, location, transferMechanism }, index) => (
                <tr key={index} className="border-b border-gray-200">
                  <td className="px-4 py-3 text-sm font-medium text-text">{name}</td>
                  <td className="px-4 py-3 text-sm text-text">{purpose}</td>
                  <td className="px-4 py-3 text-sm text-text">{location}</td>
                  <td className="px-4 py-3 text-sm text-text">{transferMechanism}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};
